module.exports = __webpack_public_path__ + "static/bordeaux-ad04b2315712d7abe038da3773f4c375.jpg";